let Tips = {}
Tips.install = function (Vue, options) {
  Vue.prototype.$dialog = (options) => {
    let confirmVue = Vue.extend(require('./dialog.vue').default)
    let tpl = new confirmVue({data:options}).$mount().$el
    document.body.appendChild(tpl)
  }
}
module.exports = Tips



// WEBPACK FOOTER //
// ./src/plugins/dialog/dialog.js